import { GREY_CHATEAU, SECONDARY_THEME_COLOR } from "../../consts/colors";

export const styles={
  backButtonContainer: {
    padding: "5px",
    border: `1px solid ${GREY_CHATEAU}`,
    borderRadius:"5px",
    cursor:"pointer",
    width:"max-content"
  },
  backButton: {
    color: SECONDARY_THEME_COLOR,
  },
}